import { DestroyRef, Injectable, ViewContainerRef } from '@angular/core';
import { HashMap, TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';
import { UiCalloutMessageComponent } from '@markant-platform/shared/ui-callout-message';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  appComponentViewRef?: ViewContainerRef;
  private readonly errorTimeout = 15; //seconds
  private readonly successTimeout = 5; //seconds

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly destroyRef: DestroyRef
  ) {}

  showErrorSnackbarWithTransloco(
    pathToMessage = 'error.occurred',
    options?: HashMap<string>,
    viewRef?: ViewContainerRef,
    ignoreTimeout = false
  ): void {
    this.translocoService
      .selectTranslate(pathToMessage, options)
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(messageString => this.showErrorSnackbar(messageString, viewRef, ignoreTimeout));
  }

  showErrorSnackbar(message: string, viewRef?: ViewContainerRef, ignoreTimeout = false): void {
    const container = viewRef ?? this.appComponentViewRef;
    if (!container) {
      return;
    }
    const component = container.createComponent(UiCalloutMessageComponent);
    const instance = component.instance;

    instance.message = message;
    instance.closeable = true;
    instance.type = 'error';
    if (!ignoreTimeout) {
      instance.timeout = this.errorTimeout;
    }
    instance.closed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => component.destroy());
  }

  showSuccessSnackbarWithTransloco(
    pathToMessage: string,
    options?: HashMap<string>,
    viewRef?: ViewContainerRef,
    ignoreTimeout = false
  ): void {
    const container = viewRef ?? this.appComponentViewRef;
    if (!container) {
      return;
    }
    const component = container.createComponent(UiCalloutMessageComponent);
    const instance = component.instance;

    const translocoSubscription = this.translocoService
      .selectTranslate(pathToMessage, options)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(messageString => (instance.message = messageString));

    instance.closeable = true;
    instance.type = 'success';
    if (!ignoreTimeout) {
      instance.timeout = this.successTimeout;
    }
    instance.closed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      translocoSubscription.unsubscribe();
      component.destroy();
    });
  }
}
